import { Link } from 'react-router';
import { Home } from 'lucide-react';
import { Button } from '@/app/components/ui/button';

export default function NotFound() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-muted-foreground mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
        <p className="text-muted-foreground mb-6">
          The page you're looking for doesn't exist.
        </p>
        <Button asChild>
          <Link to="/">
            <Home className="size-4 mr-2" />
            Go Home
          </Link>
        </Button>
      </div>
    </div>
  );
}
